import { DatePicker, Flex, Input } from 'antd';

import { SearchButtons } from '@app/components';
import { DATE_PICKER_FORMAT } from '@app/constants';

import type { OrganizationAnalyticsFiltersProps } from '../types';
import type { Dayjs } from 'dayjs';

const { RangePicker } = DatePicker;

export const OrganizationAnalyticsFilters = ({
  search,
  setSearch,
  period,
  setPeriod,
  handleReset,
  handleSearch,
}: OrganizationAnalyticsFiltersProps) => {
  return (
    <Flex className="filters" vertical gap={16}>
      <Input
        placeholder="Поиск организации"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        allowClear
        style={{ width: 250 }}
      />
      <Flex justify="space-between" align="center">
        <RangePicker
          format={DATE_PICKER_FORMAT}
          value={period}
          onChange={(value) => setPeriod(value as [Dayjs, Dayjs] | null)}
        />
        <SearchButtons
          className="desktop-buttons"
          resetAll={handleReset}
          showData={handleSearch}
        />
      </Flex>
    </Flex>
  );
};
